import {gameStateTypes} from "../GameStates";
import Confetti from "react-confetti";
import { SocialIconsRow } from "./SocialIcons";

const GameClosed = ({ gameState }) => {
  return (
    <div>
      {gameState.state === gameStateTypes.closed && <Confetti />}
      <div className="game-closed">
        {gameState.state === gameStateTypes.waiting && (
          <h1>Ben je er klaar voor?</h1>
        )}
        {gameState.state === gameStateTypes.closed && (
          <h1>Het was een feestje met jou!</h1>
        )}
        {gameState.state === gameStateTypes.closed && (
          <div>
            <div className="instagram-astrix d-flex align-items-center pt-2 justify-content-center">
              <SocialIconsRow className="social-icons-inline" />
              <span>Deel je ervaring op de socials</span>
            </div>
            <span className="instagram-astrix">
              <a
                href="https://www.instagram.com/opwekkingteenzone/"
                target="_blank"
                rel="noreferrer"
                className="text-white"
                style={{ fontSize: "30px" }}
              >
                @opwekkingteenzone
              </a>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GameClosed;
